import React, { useCallback } from "react";
import { Box, Button } from "@mui/material";
import { IconSearch } from "@tabler/icons-react";
import SearchAutocomplete from "./SearchAutocomplete";

/*const normalizeCategoriesParam = (categoryIds) => {
  if (!categoryIds || categoryIds.length === 0) return [];
  return categoryIds
    .map((value) => String(value).trim())
    .filter(Boolean);
};*/

function SearchBar({
  value,
  onChange,
  onEnter,
  onSelect,
  onSearch,
  isLoading = false,
  isMobile = false,
  searchAutocompleteRef,
  resolveCategoriesParam,
  placeholder = "Wyszukaj",
}) {
  /*const [searchParams, setSearchParams] = useSearchParams();

  const updateSearchParams = useCallback((nextValue, suggestion = null) => {
    const nextParams = new URLSearchParams(searchParams);
    const normalizedSearch = (nextValue || "").trim();
    const currentSearch = (searchParams.get("q") || "").trim();
    if (normalizedSearch) {
      nextParams.set("q", normalizedSearch);
    } else {
      nextParams.delete("q");
    }
    const resolvedCategories = resolveCategoriesParam ? resolveCategoriesParam(suggestion) : [];
    const normalizedCategories = normalizeCategoriesParam(resolvedCategories);
    const currentCategories = normalizeCategoriesParam(
      (searchParams.get("categories") || "").split(",")
    );
    const hasSameCategories = normalizedCategories.join(",") === currentCategories.join(",");
    if (normalizedCategories.length > 0) {
      nextParams.set("categories", normalizedCategories.join(","));
    } else {
      nextParams.delete("categories");
    }
    if (normalizedSearch === currentSearch && hasSameCategories) {
      return;
    }
   
    console.log("debug handle search updateSearchParams", nextParams)
    setSearchParams(nextParams, { replace: true });
  }, [searchParams, setSearchParams, resolveCategoriesParam]);
*/
  const handleEnter = useCallback((searchValue) => {
    if (onEnter) {
      onEnter(searchValue);
    }
    //updateSearchParams(searchValue);
  }, [onEnter]);

  const handleSelect = useCallback((suggestion) => {
    if (onSelect) {
      onSelect(suggestion);
    }
    //const nextValue = suggestion?.title ?? value ?? "";
    //updateSearchParams(nextValue, suggestion);
  }, [onSelect]);

  const handleSearchClick = useCallback(() => {
    if (onSearch) {
      onSearch();
    }
    //updateSearchParams(value);
  }, [onSearch]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
        px: { xs: 1, sm: 2 },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: "stretch",
          gap: { xs: 1.5, sm: 2 },
          width: "75%",
          maxWidth: "100%",
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <SearchAutocomplete
            ref={searchAutocompleteRef}
            value={value}
            onChange={onChange}
            onEnter={handleEnter}
            onSelect={handleSelect}
            placeholder={placeholder}
          />
        </Box>
        <Button
          id="search-button"
          variant="contained"
          size={isMobile ? "medium" : "large"}
          onClick={handleSearchClick}
          disabled={isLoading}
          startIcon={<IconSearch />}
          sx={{
            minWidth: { xs: "100%", sm: "auto" },
            px: { xs: 2, sm: 3 },
          }}
        >
          {isLoading ? "Wyszukiwanie..." : "Wyszukaj"}
        </Button>
      </Box>
    </Box>
  );
}

export default SearchBar;
